/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ReportScope {
	CurrentPortfolio = 1,
	PortfolioIDList = 2,
	Organization = 3,
}
